export default __webpack_public_path__ + "static/media/HOD.2c40a55c.webp";